import StripeEye from './stripe-eye-icon';
import VisibleEye from './visible-eye-icon';

const bodyIcons = { StripeEye, VisibleEye };

export default bodyIcons;
